import React from 'react';
import FlexionChart from './FlexionChart';

export default function KneeFlexionChart({ timeSeriesData, height = "400px" }) {
  if (!timeSeriesData || timeSeriesData.length === 0) {
    return null; // Don't render anything if no data
  }

  return (
    <FlexionChart
      title="Knee Flexion Analysis (Normalized)"
      timeSeriesData={timeSeriesData}
      leftDataKey="left_knee_flexion_norm"
      rightDataKey="right_knee_flexion_norm"
      height={height}
      yAxisLabel="Knee Flexion (degrees)"
      leftColor="#1976D2"
      rightColor="#FF6B35"
    />
  );
}
